import { gql } from '@apollo/client';

export const PRODUCT_PACKAGINGS = gql`
  query ProductPackagings(
    $filters: ProductPackagingsFilterInput
    $sort: ProductPackagingsSortInput
  ) {
    productPackagings(filters: $filters, sort: $sort) {
      productPackagings {
        id
        productName
        quantity
        packagingBindis {
          key
          qty
        }
        product {
          id
          name
        }
        createdAt
        updatedAt
        createdBy {
          id
          firstName
          lastName
        }
      }
      count
    }
  }
`;

export const PRODUCT_PACKAGING = gql`
  query ProductPackaging($where: UniqueWhereInput!) {
    productPackaging(where: $where) {
      id
      productName
      quantity
      packagingBindis {
        key
        qty
      }
      product {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;